module.exports = __webpack_public_path__ + "static/media/radarsoft.b4b92b39.webp";